import { gql } from "@apollo/client";

export const GET_CANDIDATE_ATTACHMENTS = gql`
  query GetCandidateAttachments($candidateId: Int!) {
    candidateAttachments(candidateId: $candidateId) {
      id
      candidateId
      originalFileName
      contentType
      fileSizeBytes
      attachmentType
      description
      uploadedById
      uploadedByName
      createdAtUtc
      updatedAtUtc
    }
  }
`;

export const GET_JOB_ATTACHMENTS = gql`
  query GetJobAttachments($jobId: Int!) {
    jobAttachments(jobId: $jobId) {
      id
      jobId
      originalFileName
      contentType
      fileSizeBytes
      attachmentType
      description
      uploadedById
      uploadedByName
      createdAtUtc
      updatedAtUtc
    }
  }
`;

export const GET_ATTACHMENT_DOWNLOAD_URL = gql`
  query GetAttachmentDownloadUrl($attachmentId: String!) {
    attachmentDownloadUrl(attachmentId: $attachmentId)
  }
`;